
$(document).ready(function() {
	$('.variant-input input').change(function() {
		var va = $("span[data-variant-color-label]").text();	
      console.log(va)
     //  var str1 = "14K Gold";
     // var str2 = "10K Gold";
      if (va == "14K Gold") {
          $(".capitalize").show();
      }
     else if(va == "10K Gold"){
      $(".capitalize").show();
     }
      else{
          $(".capitalize").hide();
      }
	});
  }); 

 $(window).on('load', function () {   
	 var vaa = $("span[data-variant-color-label]").text(); 
   let result = vaa.trim();
   console.log(vaa)
      if (result == "14K Gold") {
          $(".capitalize").show();
      }
     else if(result == "10K Gold"){
      $(".capitalize").show();
     }
      else{
          $(".capitalize").hide();
      }
});

